import { Backdrop, CircularProgress, Dialog, Tooltip } from "@mui/material";
import { X } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { QuestionCircleFill } from "react-bootstrap-icons";
import API from "../../API/newIndex";
import { ChangePathContext } from "../../App";
import { BardSvg } from "../../Assets/StaticData/BardSvg";
import { Transition } from "../../controllers/Transition";
import Notification from "../Notification";
import { uploadTextEditorImage } from "../../utilities/staticFunction";
import {
  ButtonComponent,
  InputComponent,
  RichTextEditor,
} from "@shopeasy-dashboard-ui/ui-library";
import TextareaComponent from "../FormInput/TextareaComponent";

function SendMail({ openSendMail, setOpenSendMail }) {
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const [severity, setSeverity] = useState();
  const [mailValue, SetMailValue] = useState("");
  const [mailSubject, setMailSubject] = useState("");
  const [err, setErr] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const handleSendMail = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      const payload = {
        description: mailValue,
        subject: mailSubject,
      };
      const data = await API({
        url: "/admin/newsletter/sendemails",
        method: "post",
        data: payload,
      });
      if (data.status === 200 || data.status === 304) {
        setIsNotification(true);
        setSaveChanges({
          isUnsaveChanges: false,
          showChangesPopup: false,
          backLink: "/newsletter",
          title: "send mail",
        });
        setNotificationMsg("Mail send SuccessFully");
        setSeverity("success");
        setMailSubject("");
        SetMailValue("");
        setErr(false);
        setOpenSendMail(false);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const [AiLoader, setAiloader] = useState(false);
  const [generateAiPopup, setGenareteAiPopup] = useState(false);
  const [gerenateAiData, setGenerateDataAi] = useState({
    features: "",
  });

  const handleChangeAiData = (e) => {
    setGenerateDataAi({ ...gerenateAiData, [e.target.name]: e.target.value });
  };

  const handleSubmitAiData = (e) => {
    e.preventDefault();
    generateDesc(gerenateAiData);
    setGenareteAiPopup(false);
    setGenerateDataAi({
      features: "",
    });
  };

  const generateDesc = async () => {
    setAiloader(true);
    try {
      const payload = {
        keypoints: gerenateAiData?.features,
      };
      let ApiCall = await API({ url: "/admin/ai/generate_mail", method: "post", data: payload });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        SetMailValue(result?.data);
      }
    } catch (error) {
      if (error?.response?.status === 429) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Hit_chatgpt_limit"));
        setSeverity("warning");
      } else {
        setIsNotification(true);
        setNotificationMsg(error?.response?.data?.message);
        setSeverity("error");
      }
    } finally {
      setAiloader(false);
    }
  };

  useEffect(() => {
    if (mailValue?.length > 0 || mailSubject?.length > 0) {
      setSaveChanges({
        backLink: "/dashboard",
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "send mail",
      });
    } else {
      setSaveChanges({
        backLink: "/dashboard",
        isUnsaveChanges: false,
        showChangesPopup: false,
        title: "send mail",
      });
    }
  }, [mailValue, mailSubject]);
  return (
    <>
      <Dialog
        open={openSendMail}
        TransitionComponent={Transition}
        onClose={() => {
          setOpenSendMail(false);
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="secondary-bg-color group shadow space-y-4 rounded-[6px] p-[25px]">
          {AiLoader && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={AiLoader}
              className="flex flex-col"
            >
              <CircularProgress color="inherit" />
              <p>{t("lang_Please_Wait")}</p>
            </Backdrop>
          )}
          {isNotification && notificationMsg && (
            <Notification message={notificationMsg} close={handleClose} severity={severity} />
          )}
          <div className="w-full flex items-center justify-between">
            <div className="text-base font-medium text-primary">
              <span className="font-medium text-lg">{t("lang_Send_Mail")}</span>
              <p className="text-xs table-text font-normal">{t("lang_Send_Mail_Details")}</p>
            </div>
            <div>
              <button
                type="button"
                className="close-btn"
                onClick={() => {
                  setOpenSendMail(false);
                }}
              >
                <X className="h-4 w-4" aria-hidden="true" />
              </button>
            </div>
          </div>
          <form
            onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
            className="w-full mx-auto rounded-[6px]"
          >
            <div className="mb-4">
              <InputComponent
                id="description"
                name="subject"
                label={t("lang_Subject")}
                required
                value={mailSubject}
                onChange={(e) => setMailSubject(e.target.value)}
                placeholder="Mail subject"
                error={err && mailSubject === "" ? t("lang_Please_Enter_Subject") : ""}
                autoFocus
              />
            </div>
            <div className="mb-4">
              <label htmlFor="Description" className="capitalize text-[var(--primary-text-color)] font-medium text-[13px] block mb-1">
                {t("lang_description")}
                <span className="text-red-500 ms-1">*</span>
              </label>
              <RichTextEditor
                htmlData={mailValue}
                setHtmlData={SetMailValue}
                uplaodImageFile={uploadTextEditorImage}
                onAiGenerate={() => setGenareteAiPopup(true)}
              />
              <div className="flex items-center justify-between">
                {err && mailValue === "" && (
                  <p className="text-xs text-red-500">{t("lang_Please_Enter_Subject")}</p>
                )}
                <p className="w-full text-xs mt-0 text-gray-400">{t("lang_Words_Allowed")}</p>
              </div>
            </div>
            <div>
              <ButtonComponent
                variant="primary"
                size="md"
                disabled={mailValue === "" || mailSubject === "" || btnLoading}
                loading={btnLoading}
                onClick={(e) => {
                  if (mailValue !== "" && mailSubject !== "" && !btnLoading) {
                    handleSendMail(e);
                  }
                }}
              >
                {btnLoading ? `${t("lang_loading")}...` : t("lang_Send_Mail_To_All")}
              </ButtonComponent>
            </div>
          </form>
        </div>
      </Dialog>
      <Dialog
        open={generateAiPopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setGenareteAiPopup(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="w-[600px] max-h-full">
          <div className="relative secondary-bg-color shadow dark:bg-gray-700 p-5">
            <div className="flex items-center text-primary justify-between secondary-bg-color border-b main-border-color mb-3 pb-3 rounded-t dark:border-gray-600">
              <h6 className="flex items-center justify-between capitalize font-medium gap-1 text-[var(--primary-text-color)]">
                <BardSvg /> {t("lang_Generate_Mail_Description")}
              </h6>
              <button
                type="button"
                className="close-btn"
                onClick={() => {
                  setGenareteAiPopup(false);
                }}
              >
                <X className="h-4 w-4" aria-hidden="true" />
              </button>
            </div>
            <form
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              onSubmit={handleSubmitAiData}
            >
              <div className="mb-4">
                <TextareaComponent
                  name="features"
                  value={gerenateAiData?.features}
                  onChange={handleChangeAiData}
                  placeholder="e.g. Organic cotten, relaxed fit"
                  rows={3}
                  label={t("lang_features_and_keywords")}
                  labelAction={
                    <Tooltip
                      title="Add features and keywords for better description"
                      arrow
                      placement="right"
                      className="ml-2 -tracking-tighter"
                    >
                      <QuestionCircleFill className="info-link cursor-pointer" />
                    </Tooltip>
                  }
                />
              </div>

              <ButtonComponent
                type="submit"
                variant="primary"
                size="md"
                className="capitalize"
              >
                {t("lang_done")}
              </ButtonComponent>
            </form>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export default SendMail;
